export default __webpack_public_path__ + "static/media/laundry2-beforeB-1440w.446a9fbf.png";